import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import CurrencySelect from './CurrencySelect'
import AddBlockDialog from './AddBlockDialog'
import TransactionBlocks from '../TransactionBlocks'
import { CalculatorContext } from '../Context/CalculatorContext'
import StorageBlock from '../StorageBlock'
import MasterDeliveryBlock from '../MasterDeliveryBlock'
import RestoreBlock from '../RestoreBlock'
import MigrationBlock from '../MigrationBlock'
import Box from '../Box'
import ProxyRegenerationBlock from '../ProxyRegenerationBlock/ProxyRegenerationBlock'

const useStyles = makeStyles((theme) => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    }
}))

const Calculator = ({
    transactionCost,
    setTransactionCost,
    storageCost,
    setStorageCost,
    masterDeliveryCost,
    setMasterDeliveryCost,
    restoreCost,
    setRestoreCost,
    migrationCost,
    setMigrationCost,
    proxyRegenerationCost,
    setProxyRegenerationCost
}) => {
    const { currency, setCurrency } = useContext(CalculatorContext)

    const [transactionBlocks, setTransactionBlocks] = useState({
        'transaction-block-0': { items: {}, suffix: null }
    })
    const [transactionBlockCount, setTransactionBlockCount] = useState(1)

    const [showAddBlockDialog, setShowAddBlockDialog] = useState(false)
    const [showMasterDelivery, setShowMasterDelivery] = useState(false)
    const [showMigration, setShowMigration] = useState(false)
    const [showRestore, setShowRestore] = useState(false)
    const [showProxyRegeneration, setShowProxyRegeneration] = useState(false)

    const addTransactionBlock = () => {
        setTransactionBlocks({
            ...transactionBlocks,
            [getBlockId()]: { items: {}, suffix: null }
        })
        setTransactionBlockCount((prev) => prev + 1)
    }

    const addBlock = (type) => {
        return {
            migration: () => setShowMigration(true),
            masterDelivery: () => setShowMasterDelivery(true),
            restore: () => setShowRestore(true),
            transaction: () => addTransactionBlock(),
            proxyRegeneration: () => setShowProxyRegeneration(true)
        }[type]()
    }

    const getBlockId = () => {
        return `transaction-block-${transactionBlockCount}`
    }

    const classes = useStyles()

    return (
        <Box boxShadow={2}>
            <div className={classes.header}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setShowAddBlockDialog(true)}
                >
                    Add block
                </Button>
                <CurrencySelect
                    onChange={(value) => setCurrency(value)}
                    value={currency}
                />
            </div>

            <TransactionBlocks
                cost={transactionCost}
                setCost={setTransactionCost}
                blocks={transactionBlocks}
                setBlocks={setTransactionBlocks}
            />

            <StorageBlock cost={storageCost} setCost={setStorageCost} />

            {showMasterDelivery ? (
                <MasterDeliveryBlock
                    cost={masterDeliveryCost}
                    setCost={setMasterDeliveryCost}
                    setShowBlock={setShowMasterDelivery}
                />
            ) : null}

            {showMigration ? (
                <MigrationBlock
                    cost={migrationCost}
                    setCost={setMigrationCost}
                    setShowBlock={setShowMigration}
                />
            ) : null}

            {showRestore ? (
                <RestoreBlock
                    cost={restoreCost}
                    setCost={setRestoreCost}
                    setShowBlock={setShowRestore}
                />
            ) : null}

            {showProxyRegeneration ? (
                <ProxyRegenerationBlock
                    cost={proxyRegenerationCost}
                    setCost={setProxyRegenerationCost}
                    setShowBlock={setShowProxyRegeneration}
                />
            ) : null}

            <AddBlockDialog
                dialog={showAddBlockDialog}
                setDialog={setShowAddBlockDialog}
                createBlock={addBlock}
                showMasterDelivery={!showMasterDelivery}
                showMigration={!showMigration}
                showRestore={!showRestore}
                showProxyRegeneration={!showProxyRegeneration}
            />
        </Box>
    )
}

Calculator.propTypes = {
    transactionCost: PropTypes.object,
    setTransactionCost: PropTypes.func,
    storageCost: PropTypes.object,
    setStorageCost: PropTypes.func,
    masterDeliveryCost: PropTypes.object,
    setMasterDeliveryCost: PropTypes.func,
    restoreCost: PropTypes.number,
    setRestoreCost: PropTypes.func,
    migrationCost: PropTypes.number,
    setMigrationCost: PropTypes.func
}

export default Calculator
